import { render, staticRenderFns } from "./bd.vue?vue&type=template&id=6fe71998&"
import script from "./bd.vue?vue&type=script&lang=js&"
export * from "./bd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports